<template>
    <el-dialog
        :title="translate('transformation_percentage')"
        :visible="visible"
        width="400px"
        :before-close="handleClose"
        append-to-body
    >
        <div v-loading="loading">
            <el-form
                :model="form"
                ref="form"
                :rules="rules"
                label-position="top"
            >
                <el-form-item :label="translate('casca')" prop="casca">
                    <el-input-number
                        v-model="form.casca"
                        :min="0"
                        :max="100"
                        :precision="2"
                        :step="0.1"
                        style="width: 100%"
                    ></el-input-number>
                </el-form-item>
                <el-form-item :label="translate('farinha')" prop="farinha">
                    <el-input-number
                        v-model="form.farinha"
                        :min="0"
                        :max="100"
                        :precision="2"
                        :step="0.1"
                        style="width: 100%"
                    ></el-input-number>
                </el-form-item>
                <el-form-item :label="translate('oleo')" prop="oleo">
                    <el-input-number
                        v-model="form.oleo"
                        :min="0"
                        :max="100"
                        :precision="2"
                        :step="0.1"
                        style="width: 100%"
                    ></el-input-number>
                </el-form-item>

                <div v-if="totalSum > 100" class="error-message">
                    {{ translate('sum_must_be_less_than_100') }}
                </div>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">{{
                $t('warehouse.messages.view.cancel')
            }}</el-button>
            <el-button
                type="primary"
                @click="handleSave"
                :disabled="isSaveDisabled"
                :loading="loading"
            >
                {{ $t('mensagens.comuns.salvar') }}
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import RastreabilidadeFabricaService from '@/services/RastreabilidadeFabricaService';

export default {
    name: 'TransformationPercentageModal',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        factory: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            visible: false,
            loading: false,
            form: {
                casca: undefined,
                farinha: undefined,
                oleo: undefined
            },
            rules: {
                casca: [
                    {
                        required: true,
                        message: this.translate('field_required'),
                        trigger: 'blur',
                        type: 'number'
                    },
                    {
                        type: 'number',
                        min: 0.01,
                        message: this.translate('field_required'),
                        trigger: 'blur'
                    }
                ],
                farinha: [
                    {
                        required: true,
                        message: this.translate('field_required'),
                        trigger: 'blur',
                        type: 'number'
                    },
                    {
                        type: 'number',
                        min: 0.01,
                        message: this.translate('field_required'),
                        trigger: 'blur'
                    }
                ],
                oleo: [
                    {
                        required: true,
                        message: this.translate('field_required'),
                        trigger: 'blur',
                        type: 'number'
                    },
                    {
                        type: 'number',
                        min: 0.01,
                        message: this.translate('field_required'),
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    computed: {
        totalSum() {
            return (
                (Number(this.form.casca) || 0) +
                (Number(this.form.farinha) || 0) +
                (Number(this.form.oleo) || 0)
            );
        },
        isSaveDisabled() {
            const allFieldsFilled =
                this.form.casca > 0 &&
                this.form.farinha > 0 &&
                this.form.oleo > 0;
            return this.totalSum > 100 || !allFieldsFilled;
        }
    },
    watch: {
        show(val) {
            this.visible = val;
            if (val) {
                this.loadData();
            }
        },
        visible(val) {
            this.$emit('update:show', val);
        }
    },
    methods: {
        translate(key) {
            return this.$t(`warehouse.messages.${key}`);
        },
        loadData() {
            if (this.factory && this.factory.id) {
                this.loading = true;
                RastreabilidadeFabricaService.getTransformationPercentages(
                    this.factory.id
                )
                    .then(({ data }) => {
                        if (data) {
                            this.form.casca = data.porcentagemConversaoCasca;
                            this.form.farinha =
                                data.porcentagemConversaoFarinha;
                            this.form.oleo = data.porcentagemConversaoOleo;
                        } else {
                            this.resetForm();
                        }
                    })
                    .catch(() => {
                        this.resetForm();
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        resetForm() {
            this.form.casca = undefined;
            this.form.farinha = undefined;
            this.form.oleo = undefined;
        },
        handleClose(done) {
            this.$emit('update:show', false);
            this.visible = false;
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
            this.resetForm();
            if (typeof done === 'function') {
                done();
            }
        },
        handleSave() {
            this.$refs.form.validate(valid => {
                if (valid && !this.isSaveDisabled) {
                    this.loading = true;
                    const payload = {
                        porcentagemConversaoCasca: this.form.casca,
                        porcentagemConversaoFarinha: this.form.farinha,
                        porcentagemConversaoOleo: this.form.oleo
                    };
                    RastreabilidadeFabricaService.saveTransformationPercentages(
                        this.factory.id,
                        payload
                    )
                        .then(() => {
                            this.$notify.success(
                                this.$t('mensagens.comuns.salvoComSucesso') ||
                                    'Salvo com sucesso'
                            );
                            this.handleClose();
                        })
                        .catch(() => {
                            this.$notify.error(
                                this.$t('mensagens.comuns.erroSalvar') ||
                                    'Erro ao salvar'
                            );
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            });
        }
    }
};
</script>

<style scoped>
.error-message {
    color: #f56c6c;
    font-size: 12px;
    margin-top: 20px;
}
.info-message {
    color: #909399;
    font-size: 12px;
    margin-top: 10px;
}
</style>
